/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } 	            from 'react';
import { connect }                          from 'react-redux';
import { bindActionCreators }               from 'redux';
import FontAwesome from 'react-fontawesome';

import moment from 'moment'

import { updateSearch }      from '../../../redux/actions/search';

import { fetch } 							from '@fyresite/fetch';
import TextInput							from '../../../components/TextInput'
import Pagination 						    from '../../../components/Pagination';

const PERPAGE = 10;

class ListMembers extends Component {
	constructor(props, context){
		super(props, context);
		this.state = Object.assign({}, {
			members: [],
			currentPage: 1,
			pages: 0,
			firstName: '',
			lastName: '',
			nordIdentifier: '',
			dateOfBirth: '',
			totalMembers: 0
        }, this.props.search);

      this.handleInputKeyPress = this.handleInputKeyPress.bind(this)
    }

    componentWillUnmount(){
      document.removeEventListener("keydown", this.handleInputKeyPress);
    }
    componentWillMount(){
      document.addEventListener("keydown", this.handleInputKeyPress);
    }
    componentDidMount(){
      this.allMembers()
    }
    handleInputKeyPress(e){
      if(e.key.toLowerCase() === 'enter'){
				this.searchMembers();
      }
    }

    async allMembers() {
        // let status;
        fetch(`/api/v1/member/get/${this.state.currentPage}?perPage=${PERPAGE}`, {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
        }).then(res => {
            // status = res.status;
            return res.json();
        }).then(json => {
            if(json.code === 200){
                this.setState({
                    members: json.result.members,
                    pages: Math.ceil(json.result.count / PERPAGE),
                    totalMembers: json.result.count
                }, () => {
                    this.props.updateSearch(this.state);
                });
            } else {
                Materialize.toast(`Error occurred, ${json.message}`, 4000, 'red');
            }
        }).catch(err => {
            Materialize.toast(`Fetch error ${err}`, 4000, 'red');
        })
    }

    async searchMembers() {
			if(this.state.firstName.length > 0 || this.state.lastName.length > 0
					|| this.state.dateOfBirth.length > 0 || this.state.nordIdentifier.length > 0){
						// let status;
						fetch(`/api/v1/member/get/${this.state.currentPage}?perPage=${PERPAGE}&dateOfBirth=${new Date(this.state.dateOfBirth)}
										&nordIdentifier=${this.state.nordIdentifier}&lastName=${this.state.lastName}&firstName=${this.state.firstName}`, {
								method: 'GET',
								headers: { "Content-Type": "application/json" }
						}).then(res => {
								// status = res.status;
								return res.json();
						}).then(json => {
								if(json.code === 200){
										this.setState({
												members: json.result.members,
												pages: Math.ceil(json.result.count / PERPAGE),
												totalMembers: json.result.count
										}, () => {
												this.props.updateSearch(this.state);
										});
								} else {
										Materialize.toast(`Error occurred, ${json.message}`, 4000, 'red');
								}
						}).catch(err => {
								Materialize.toast(`Fetch error ${err}`, 4000, 'red');
						})
			}
			else {
				this.allMembers();
			}
    }

	/**
   * renderEmployeeList - Builds the JSX for rendering the employee list
   * since it requires a little more complex if/else handling than the
   * render() function allows
   *
   * @return {Array}  Array of JSX representing the employee list
   */
    renderMemberList() {
        let html = [];

        this.state.members.forEach((member, index) => {
	        let classes = [];

					if(member.Eligibilities.length > 0) {
						classes.push('cursorHover')
					}

	        if (member.status === 'deleted') {
	            classes.push('inactive');
	        }

					let programStatus = 'None'
					if(member.Eligibilities.length === 1) {
						programStatus = member.Eligibilities[0].Program.program
					} else if(member.Eligibilities.length > 1) {
						programStatus = 'Enrolled in Multiple'
					}

	        html.push(
	            <tr className={classes.join(' ')} key={member.id} onClick={(member.Eligibilities.length > 0) ? this.showProgramRows.bind(this, member) : ()=>{}}>
	                <td>
                        {
                            (member.Eligibilities.length > 0) ?
                                member.showPrograms ?
                                    <FontAwesome style={{paddingRight: 10}} name='chevron-down' />
                                    :
                                    <FontAwesome style={{paddingRight: 10}} name='chevron-right' />
                                :
                                ''
                        }
	                    <a onClick={e => this.props.history.push(`/dashboard/edit-member/${member.id}`)}>
	                        {`${member.firstName} ${member.lastName}`}
	                    </a>
	                </td>
			            <td> {`${moment(member.dateOfBirth).utc().format('MM-DD-YYYY')}`} </td>
									<td> {`${member.nordIdentifier}`} </td>
									<td> {programStatus} </td>
			            <td> <a onClick={e => this.props.history.push(`/dashboard/enroll-member/${member.id}`)}> Enroll </a> </td>
	            </tr>
	        );

            if(member.showPrograms) {
                html.push(
                    <tr key={`eligibility-header-${member.id}`}>
                        <td> <b> {'Program List:'} </b> </td>
                        <td> <b> {'Program Name'} </b> </td>
                        <td> <b> {'Date Enrolled'} </b> </td>
                        <td> <b> {'Member ID'} </b> </td>
                        <td> <b> {'Program Status'} </b> </td>
                    </tr>
                )
                member.Eligibilities.forEach((item, index) => {
                    let actionText = '';
                    if(item.actionCode === 'A') {
                        actionText = 'Active';
                    } else if(item.actionCode === 'T') {
                        actionText = 'Terminated';
                    }
                    html.push(
                        <tr key={`eligibility-${item.id}`}>
                            <td>{''}</td>
                            <td>{item.Program.program}</td>
                            <td>{item.createdAt.split('T')[0]}</td>
                            <td>{item.subscriberId}</td>
                            <td>{actionText}</td>
                        </tr>
                    );
                });
            }
        });

        return html;
    }

	showProgramRows(incomingMember) {
		this.state.members.forEach((member, index) => {
			if(this.state.members[index] === incomingMember) {
				let cloneState = JSON.parse(JSON.stringify(this.state))
				cloneState.members[index].showPrograms = !this.state.members[index].showPrograms
				this.setState(cloneState)
			}
			return null
		})
	}

    onSearchChange(field, e){
        this.setState({
            [field]: e.target.value
        })
    }

	handlePageChange(currentPage) {
        /** Once state is set we can update the members */
        this.setState({
            currentPage
        }, () => {
					this.searchMembers();
        })
	}

  render() {
      return (
        <div className="search-members">
            <div className="search-members-inner">
                <h4>Search Members</h4>
                <div>
                    <div className="search-box">
                        <div className="card">
                            <div className="row">
                                <form className="col s12">
                                    <div className="row">
                                        <div className="col s6">
                                            <TextInput
                                            id="firstName"
                                            ref={"firstName"}
                                            label={`First Name`}
                                            type={"text"}
                                            value={this.state.firstName}
                                            onChange={this.onSearchChange.bind(this, 'firstName')} />
                                        </div>
                                        <div className="col s6">
                                            <TextInput
                                            id="lastName"
                                            ref={"lastName"}
                                            label={`Last Name`}
                                            type={"text"}
                                            value={this.state.lastName}
                                            onChange={this.onSearchChange.bind(this, 'lastName')} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col s6">
                                            <TextInput
                                                id="nordIdentifier"
                                                ref={"nordIdentifier"}
                                                label={`NORD Member Identifier`}
                                                type={"text"}
                                                value={this.state.nordIdentifier}
                                                onChange={this.onSearchChange.bind(this, 'nordIdentifier')} />
                                        </div>
                                        <div className="col s6">
                                            <TextInput
                                                id="dateOfBirth"
                                                ref={"dateOfBirth"}
                                                label={`Date Of Birth`}
                                                type={"date"}
                                                value={this.state.dateOfBirth || '1900-01-01'}
                                                onChange={this.onSearchChange.bind(this, 'dateOfBirth')} />
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="card-action">
                                <a className="btn" onClick={this.searchMembers.bind(this, 0)}>Search</a>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="card">
                        <table className="striped bordered">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Date of Birth</th>
																		<th>Nord ID </th>
                                    <th>Program(s)</th>
                                    <th>Enroll </th>
                                </tr>
                            </thead>
                            <tbody>
                                { this.renderMemberList() }
                            </tbody>
                        </table>
                        {
                            this.state.pages > 1 ?
                            <Pagination
                                total={this.state.totalMembers}
                                current={this.state.currentPage}
                                onChange={this.handlePageChange.bind(this)}
                                perPage={PERPAGE} />
                            : ''
                        }
                    </div>
                </div>
            </div>
        </div>
      );
  }
}

function mapStateToProps(state) {
  return {
    search: state.search
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateSearch
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ListMembers);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/SearchMember/SearchMember.js